import Seo from "./Seo";
import { Selectors } from "@/store/masterProfile/selectors";
import { connect } from "react-redux";

const mSp = (state, props) => ({
  avatar: Selectors.getAvatar(state),
  meta: Selectors.isSearchHidden(state) ? null : Selectors.getSeoMeta(state, props.specs),
  masterId: Selectors.getMasterId(state),
  currency: Selectors.getCurrency(state),
});

export default connect(mSp)(Seo);
